/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Ticketpagecheckedinshare4Inputs */

const en_ticketpagecheckedinshare4 = /** @type {(inputs: Ticketpagecheckedinshare4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent} of valid tickets`)
};

const de_ticketpagecheckedinshare4 = /** @type {(inputs: Ticketpagecheckedinshare4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent} der gültigen Tickets`)
};

/**
* | output |
* | --- |
* | "{percent} of valid tickets" |
*
* @param {Ticketpagecheckedinshare4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecheckedinshare4 = /** @type {((inputs: Ticketpagecheckedinshare4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecheckedinshare4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecheckedinshare4(inputs)
	return de_ticketpagecheckedinshare4(inputs)
});
export { ticketpagecheckedinshare4 as "ticketPageCheckedInShare" }